export const VirtualBrandText = {
  restaurant: "Restaurant",
  restaurants: "Restaurants",
  brand: "Restaurant Brand",
  brands: "Restaurant Brands"
};
